import { render, staticRenderFns } from "./WeeksList.vue?vue&type=template&id=104ddb94"
import script from "./WeeksList.vue?vue&type=script&lang=js"
export * from "./WeeksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports